import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const MatchCornersCornersRoot = styled('div', { label: 'MatchCornersCornersRoot' })`
    width: 100%;
`;

export const HeaderCell = withConfig(theme => styled('span', { label: 'HeaderCell' })<{ isLine?: boolean }>`
    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    text-align: ${({ isLine }): string => (isLine === true ? 'left' : 'center')};
    width: 100%;
`);

export const MarketRows = styled('div', { label: 'MarketRows' })`
    align-items: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0;
`;

export const LineCell = withConfig(theme => styled('div', { label: 'LineCell' })`
    color: ${theme.star.selectionsGroup.txtColor};
    font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};
    font-weight: ${theme.star.unified.eventRow.typography.fontWeightSecondary};
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 61px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 0 8px;
`);

export const SelectionCell = withConfig(theme => styled('div', { label: 'SelectionCell' })`
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    padding: 8px 4px;

    &:has(+ [class$='LineCell']), &:last-of-type {
        padding-right: 8px;
    }

    .selection {
        display: flex;
        justify-content: center;
        flex: 1;
        align-self: stretch;
    }
`);
